import { Action } from '@ngrx/store';
import { TTnaApprovalsActionType } from './tna-approvals.models';
import {
  TUserPaginationOption,
  TREQUEST_GET_TNA_STEP_APPROVAL_LIST,
  TRESPONSE_GET_TNA_STEP_APPROVAL_LIST,
  TTnaStepApprovalsFetchReason,
  TRESPONSE_GET_TNA_STEP_APPROVAL_DETAILS,
  TREQUEST_CREATE_TNA_STEP_APPROVAL_REQUEST,
  TRESPONSE_GET_TNA_STEP_APPROVAL_PENDING_LIST,
  TREQUEST_UPDATE_TNA_STEP_APPROVAL,
  TRESPONSE_GET_TNA_STEP_APPROVAL_PENDING_DETAILS,
  TREQUEST_GET_TNA_STEP_APPROVAL_PENDING_LIST,
} from '@monorepo/types';

export class GetTnaStepApprovalList implements Action {
  readonly type = TTnaApprovalsActionType.GetTnaStepApprovalList;
  constructor(public payload: TREQUEST_GET_TNA_STEP_APPROVAL_LIST, public fetchReason: TTnaStepApprovalsFetchReason) {}
}

export class GetTnaStepApprovalListSuccess implements Action {
  readonly type = TTnaApprovalsActionType.GetTnaStepApprovalListSuccess;
  constructor(
    public tnaApprovalList: TRESPONSE_GET_TNA_STEP_APPROVAL_LIST,
    public fetchReason: TTnaStepApprovalsFetchReason,
  ) {}
}

export class GetTnaStepApprovalListFailure implements Action {
  readonly type = TTnaApprovalsActionType.GetTnaStepApprovalListFailure;
}

export class GetTnaStepApprovalDetails implements Action {
  readonly type = TTnaApprovalsActionType.GetTnaStepApprovalDetails;
  constructor(public tosId: TRESPONSE_GET_TNA_STEP_APPROVAL_LIST['tnaOrderStepItemList'][number]['tosId']) {}
}

export class GetTnaStepApprovalDetailsSuccess implements Action {
  readonly type = TTnaApprovalsActionType.GetTnaStepApprovalDetailsSuccess;
  constructor(
    public tnaStepApproval: TRESPONSE_GET_TNA_STEP_APPROVAL_DETAILS,
    public tosId: TRESPONSE_GET_TNA_STEP_APPROVAL_LIST['tnaOrderStepItemList'][number]['tosId'],
  ) {}
}

export class GetTnaStepApprovalDetailsFailure implements Action {
  readonly type = TTnaApprovalsActionType.GetTnaStepApprovalDetailsFailure;
}

export class TnaStepApprovalRequest implements Action {
  readonly type = TTnaApprovalsActionType.TnaStepApprovalRequest;
  constructor(
    public payload: TREQUEST_CREATE_TNA_STEP_APPROVAL_REQUEST,
    public listingPayload: TREQUEST_GET_TNA_STEP_APPROVAL_LIST,
  ) {}
}

export class TnaStepApprovalRequestSuccess implements Action {
  readonly type = TTnaApprovalsActionType.TnaStepApprovalRequestSuccess;
}

export class TnaStepApprovalRequestFailure implements Action {
  readonly type = TTnaApprovalsActionType.TnaStepApprovalRequestFailure;
}

export class GetTnaStepApprovalPendingList implements Action {
  readonly type = TTnaApprovalsActionType.GetTnaStepApprovalPendingList;
  constructor(
    public payload: TREQUEST_GET_TNA_STEP_APPROVAL_PENDING_LIST,
    public fetchReason: TTnaStepApprovalsFetchReason,
  ) {}
}

export class GetTnaStepApprovalPendingListSuccess implements Action {
  readonly type = TTnaApprovalsActionType.GetTnaStepApprovalPendingListSuccess;
  constructor(
    public tnaApprovalPendingList: TRESPONSE_GET_TNA_STEP_APPROVAL_PENDING_LIST,
    public fetchReason: TTnaStepApprovalsFetchReason,
  ) {}
}

export class GetTnaStepApprovalPendingListFailure implements Action {
  readonly type = TTnaApprovalsActionType.GetTnaStepApprovalPendingListFailure;
}

export class GetTnaStepApprovalPendingDetails implements Action {
  readonly type = TTnaApprovalsActionType.GetTnaStepApprovalPendingDetails;
  constructor(
    public approvalId: TRESPONSE_GET_TNA_STEP_APPROVAL_PENDING_LIST['stepApprovalPendingItems'][number]['tnaStepApprovalId'],
  ) {}
}

export class GetTnaStepApprovalPendingDetailsSuccess implements Action {
  readonly type = TTnaApprovalsActionType.GetTnaStepApprovalPendingDetailsSuccess;
  constructor(
    public tnaStepApprovalPending: TRESPONSE_GET_TNA_STEP_APPROVAL_PENDING_DETAILS,
    public approvalId: TRESPONSE_GET_TNA_STEP_APPROVAL_PENDING_LIST['stepApprovalPendingItems'][number]['tnaStepApprovalId'],
  ) {}
}

export class GetTnaStepApprovalPendingDetailsFailure implements Action {
  readonly type = TTnaApprovalsActionType.GetTnaStepApprovalPendingDetailsFailure;
}

export class UpdateTnaStepApproval implements Action {
  readonly type = TTnaApprovalsActionType.UpdateTnaStepApproval;
  constructor(
    public payload: TREQUEST_UPDATE_TNA_STEP_APPROVAL,
    public listingPayload: TREQUEST_GET_TNA_STEP_APPROVAL_PENDING_LIST,
  ) {}
}

export class UpdateTnaStepApprovalSuccess implements Action {
  readonly type = TTnaApprovalsActionType.UpdateTnaStepApprovalSuccess;
}

export class UpdateTnaStepApprovalFailure implements Action {
  readonly type = TTnaApprovalsActionType.UpdateTnaStepApprovalFailure;
}

export class SetUserPaginationOption implements Action {
  readonly type = TTnaApprovalsActionType.SetUserPaginationOption;
  constructor(public userPaginationOption: TUserPaginationOption) {}
}

export type TTnaApprovalsActions =
  | GetTnaStepApprovalList
  | GetTnaStepApprovalListSuccess
  | GetTnaStepApprovalListFailure
  | GetTnaStepApprovalDetails
  | GetTnaStepApprovalDetailsSuccess
  | GetTnaStepApprovalDetailsFailure
  | TnaStepApprovalRequest
  | TnaStepApprovalRequestSuccess
  | TnaStepApprovalRequestFailure
  | GetTnaStepApprovalPendingList
  | GetTnaStepApprovalPendingListSuccess
  | GetTnaStepApprovalPendingListFailure
  | GetTnaStepApprovalPendingDetails
  | GetTnaStepApprovalPendingDetailsSuccess
  | GetTnaStepApprovalPendingDetailsFailure
  | UpdateTnaStepApproval
  | UpdateTnaStepApprovalSuccess
  | UpdateTnaStepApprovalFailure
  | SetUserPaginationOption;
